import { z } from "zod"

export const consultationFormSchema = z.object({
  medication: z.object({
    name: z.string().min(1, "Please select a medication"),
    cost: z.number().min(0, "Cost must be a positive number"),
  }),
  consultationType: z.object({
    name: z.string().min(1, "Please select a consultation type"),
    cost: z.number().min(0, "Cost must be a positive number"),
  }),
})

export type ConsultationFormSchema = z.infer<typeof consultationFormSchema>
export type ConsultationFormFieldName = keyof ConsultationFormSchema